import { Box, Text } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { BlurRow } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/BlurRow'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'
import { useFinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import { CompensationsBanner } from 'modules/finance/components/FinancialWorkspaceCompensations/components/CompensationsBanner'
import { UpsellProps } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/Table/components/types'
import { RequestInfoButton } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/components/Buttons/RequestInfo'

const RowCta = () => {
  const {
    availabilities: {
      modules: { compensations: canSeeCompensationsModule },
    },
  } = useFinancialWorkspace()

  if (canSeeCompensationsModule) {
    return <CompensationsBanner />
  }

  return (
    <Box justifyContent="center" alignItems="center" gap="s12">
      <Text.Normal size="200" weight="semibold" color="textPrimary">
        {i18n.t('finance.financial_workspace.employee_costs.upsells.payroll.title')}
      </Text.Normal>
      <Text.Normal size="200">
        {i18n.t('finance.financial_workspace.employee_costs.upsells.payroll.description')}
      </Text.Normal>
      <Box gap="s8" flexDirection="row">
        <RequestInfoButton
          source="employee_costs_table"
          featureRequested={Features.payroll_management}
        />
        <UploadPayrollButton
          type="outline"
          textButton={i18n.t('finance.financial_workspace.employee_costs.upsells.payroll.button')}
          source="employee_costs_table"
        />
      </Box>
    </Box>
  )
}

// TODO: Rename to LaborCostsUpsell: we use payroll data or compensations data for generating the labor costs
export const PayrollUpsell = ({ headerLength, tableHeadRef, level }: UpsellProps) => {
  const {
    modules: { payroll, compensations },
  } = useFinancialWorkspaceAvailabilities()

  const showLock = !(payroll || compensations)

  return (
    <BlurRow
      titleIcon={showLock ? 'lock-locked' : undefined}
      title={i18n.t('finance.financial_workspace.employee_costs.upsells.payroll.header')}
      rows={4}
      columns={headerLength}
      tableHeadRef={tableHeadRef}
      level={level}
      dataTestId="payroll-table-upsell"
      expandedByDefault
    >
      <RowCta />
    </BlurRow>
  )
}
